import React from 'react';
import './App.css';
import { connect } from 'react-redux';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Root } from './pages';
import * as selectors from './selectors';

function App({
  activeTheme,
  accountDetails,
}) {


  const primaryColor =
   (accountDetails &&
     accountDetails.extensionData &&
     accountDetails.extensionData.extensionData &&
     accountDetails.extensionData.extensionData.Themes &&
     accountDetails.extensionData.extensionData.Themes.primary) ||
   '#6ea7d2';

 const secondaryColor =
   (accountDetails &&
     accountDetails.extensionData &&
     accountDetails.extensionData.extensionData &&
     accountDetails.extensionData.extensionData.Themes &&
     accountDetails.extensionData.extensionData.Themes.secondary) ||
   '#3F7CB6';

 const newLogo =
   (accountDetails &&
     accountDetails.extensionData &&
     accountDetails.extensionData.extensionData &&
     accountDetails.extensionData.extensionData.Logos &&
     accountDetails.extensionData.extensionData.Logos.mainLogo) ||
   '';

 const theme = createTheme({
   typography: {
     useNextVariants: true,
   },
   palette: {
     primary: {
       main: primaryColor,
     },
     secondary: {
       main: secondaryColor,
     },
   },
 });

  return (
    <ThemeProvider theme={theme}>
      <Root logos={newLogo} />
    </ThemeProvider>
  );
}

export default connect(
  (state, _) => ({
    activeTheme: selectors.getActiveTheme(state),
    accountDetails: selectors.getAccountDetails(state),
  }),
  (dispatch, _) => ({}),
)(App);
